// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Інтерпеляції» (Interpellations, ключ `interpellation`, група `oversight`). */
export const interpellationsManifest: IModuleManifest = {
  key: 'interpellation',
  group: 'oversight',
  slug: 'interpellations',
  prefix: 'INT',
  name: { en: 'Interpellations', uk: 'Інтерпеляції' },
  entities: [
    { key: 'interpellation', slug: 'interpellation', name: { en: 'Interpellations', uk: 'Інтерпеляції' }, main: true },
    { key: 'interpellation_signatory', slug: 'interpellation-signatory', name: { en: 'Interpellation Signatories', uk: 'Підписанти' }, main: false },
    { key: 'interpellation_answer', slug: 'interpellation-answer', name: { en: 'Interpellation Answers', uk: 'Відповіді' }, main: false },
    { key: 'interpellation_follow_up', slug: 'interpellation-follow-up', name: { en: 'Interpellation Follow-ups', uk: 'Подальші дії' }, main: false },
    { key: 'interpellation_status', slug: 'interpellation-status', name: { en: 'Interpellation Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/interpellationsSlice').then((m) => m.interpellationsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
